import CategoryService, {ICategoryCreateEdit} from "../../api/categoryService";
import {toastError, toastSuccess} from "../../component/shared/toast/Toast";
import i18n from "../../config/i18n";
import {getSafeBackendErrorMessage} from "../../util/utils";
import {setApplicationError} from "../app/Slice";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {ICategoriesResponse} from "./Helper";
import {WishType} from "../wish/Helper";

export const getCategories =
    createAsyncThunk(`${SliceNames.CATEGORY}/getCategories`,
        async (req: { type?: WishType, includeEmpty?: boolean, sorted?: boolean } = {sorted: false}, thunkAPI) => {
            try {
                const res = await CategoryService.fetchCategoriesWithCounts({
                    wish_type: req.type,
                    include_empty: req.includeEmpty
                })
                if (req.sorted) {
                    return res.data.sort((a: ICategoriesResponse, b: ICategoriesResponse) => b.count - a.count);
                }

                return res.data
            } catch (e: any) {
                thunkAPI.dispatch(setApplicationError({isError: true, statusCode: undefined}))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const createCategory =
    createAsyncThunk(`${SliceNames.CATEGORY}/createCategory`,
        async (req: { category: ICategoryCreateEdit, handleDialogClose: () => void }, thunkAPI) => {
            try {
                const res = await CategoryService.createCategory(req.category)
                toastSuccess(i18n.t('changes_saved_success'))
                req.handleDialogClose()
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const updateCategory =
    createAsyncThunk(`${SliceNames.CATEGORY}/updateCategory`,
        async (req: { categoryId: string, category: ICategoryCreateEdit, handleCloseDialog: () => void }, thunkAPI) => {
            try {
                const res = await CategoryService.updateCategory(req.categoryId, req.category)
                req.handleCloseDialog()
                toastSuccess(i18n.t('changes_saved_success'))
                return res.data
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

export const deleteCategory =
    createAsyncThunk(`${SliceNames.CATEGORY}/deleteCategory`,
        async (req: { categoryId: string, handleDialogClose: () => void }, thunkAPI) => {
            try {
                await CategoryService.deleteCategory(req.categoryId)
                toastSuccess(i18n.t('changes_saved_success'))
                req.handleDialogClose()
                return req.categoryId
            } catch (e: any) {
                toastError(getSafeBackendErrorMessage(e.response?.data?.detail))
                return thunkAPI.rejectWithValue(e)
            }
        })

